import Vue from 'vue';
import { findIndex, clone, cloneDeep } from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';

const data = {
  intents: [],
  fetching: false,
  totalCount: 0,
  pageSizeDefault: undefined,
};

const actions = {
  async fetchIntentsPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(SET_FETCHING);
    await api.getOmiliaRequestTypesPagination(page, pageSize)
      .then(({ omiliaRequestTypes, totalCount, pageSize: pageSizeDefault }) => {
        commit('SET_INTENTS', {
          omiliaRequestTypes, totalCount, moreData, pageSizeDefault,
        });
      });
  },
  createIntent({ commit }, { model }) {
    return api.createOmiliaRequestType(model).then((intent) => {
      commit('ADD_INTENT', intent);
    });
  },
  updateIntent({ commit }, { id, model }) {
    commit(SET_FETCHING, id);
    return api.updateOmiliaRequestType(id, model).then((intent) => {
      commit('UPDATE_INTENT', intent);
    });
  },
  removeIntent({ commit }, id) {
    commit(SET_FETCHING, id);
    return api.deleteOmiliaRequestType(id)
      .then(() => commit('REMOVE_INTENT', id));
  },
};

const mutations = {
  SET_INTENTS(state, {
    omiliaRequestTypes, totalCount, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.intents = state.intents.concat(cloneDeep(omiliaRequestTypes));
    } else {
      state.intents = cloneDeep(omiliaRequestTypes);
    }
    state.totalCount = totalCount || state.totalCount;
    state.fetching = false;
  },
  SET_FETCHING(state) {
    state.fetching = true;
  },
  ADD_INTENT(state, intent) {
    state.intents.push(clone(intent));
  },
  UPDATE_INTENT(state, intent) {
    const { id } = intent;
    const { intents } = state;
    const index = findIndex(intents, { id });
    Vue.set(intents, index, { ...intents[index], ...intent });
  },
  REMOVE_INTENT(state, id) {
    const { intents } = state;
    Vue.delete(intents, findIndex(intents, { id }));
    state.totalCount -= 1;
  },
};

const getters = {
  getIntentById(state) {
    const { intents } = state;
    return (id) => (intents[findIndex(intents, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters,
};

export default store;
